import React, { useEffect, useState } from 'react'
import { useMoralis } from 'react-moralis'
import BuyNFTContainer from '../commons/NFT/BuyNFTContainer'
export default function RecentlyListedNft() {


  const { Moralis, isInitialized } = useMoralis()
  const [latestOnSaleItems, setLatestOnSaleItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized) {
      try {
        setIsLoading(true)

        const params = { limit: 8 };
        const recentSellingItemsResponse = await Moralis.Cloud.run("listRecentSellingItems", params);
        setLatestOnSaleItems(recentSellingItemsResponse)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])
  return (
    <div>
      {
        isLoading ? (
          <div className='row'>
            <div className='col-lg-12'>
              <div className='loading-container'>
                <div className="spinner-grow" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>

        ) :
          (
            <div className='row'>
              {
                latestOnSaleItems && latestOnSaleItems.length > 0 ? (
                  latestOnSaleItems.map((item, index) => (
                    <div key={index} className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <BuyNFTContainer data={item} objectId={item.objectId} />
                    </div>
                  ))
                ) : (
                  <div className='col-sm-12'>
                    <div className='loading-container'>
                      No Items found
                    </div>
                  </div>

                )
              }
            </div>
          )

      }
    </div>
  )
}
